import { datadogRum } from "@datadog/browser-rum";
function addFeatureFlagDataDog(flags = []) {
  try {
    if (datadogRum && flags.length) {
      flags.forEach(({ key, value }) => {
        const modifiedKey = key.replace(/[.:+\-=&|><!(){}[\]^"“”~*?\\\s]/g, "_");
        datadogRum.addFeatureFlagEvaluation(modifiedKey, value);
      });
    }
  } catch (error) {
    console.error("Error: failed at datadogRum.addFeatureFlagEvaluation", error == null ? void 0 : error.message);
  }
}
function initDataDogRum() {
  const customWindow = window;
  if (customWindow.__DD_RUM_CONFIG__) {
    try {
      datadogRum.init(customWindow.__DD_RUM_CONFIG__);
      delete customWindow.__DD_RUM_CONFIG__;
    } catch (error) {
      console.error("Error: Failed to initialize datadogRum client.", error.message);
    }
  }
  if (customWindow == null ? void 0 : customWindow.__DD_FEATURE_FLAGS__) {
    addFeatureFlagDataDog(customWindow.__DD_FEATURE_FLAGS__);
    delete customWindow.__DD_FEATURE_FLAGS__;
  }
}
function getContext(window2) {
  const context = {
    renderContext: window2.__CMS_ENGINE_RENDER_CONTEXT__,
    customContext: window2.__CMS_CUSTOM_RENDER_CONTEXT__ ? window2.__CMS_CUSTOM_RENDER_CONTEXT__ : void 0
  };
  delete window2.__CMS_CUSTOM_RENDER_CONTEXT__;
  delete window2.__CMS_ENGINE_RENDER_CONTEXT__;
  return context;
}
export {
  addFeatureFlagDataDog,
  getContext,
  initDataDogRum
};
